import { NavigationService } from './navigationService';

export interface NavigateToStorefrontParams {
  referralAdditionalInfo: string;
}

export const navigateToAnonymousCartDomainSplitPage = ({
  referralAdditionalInfo,
}: NavigateToStorefrontParams) => {
  const url = NavigationService.anonymousCartDomainSplitPageUrl({
    referralAdditionalInfo,
  });

  window.open(url, '_self');
};

export const navigateToAnonymousCartViewCart = ({
  referralAdditionalInfo,
}: NavigateToStorefrontParams) => {
  const url = NavigationService.anonymousCartViewCartUrl({
    referralAdditionalInfo,
  });

  window.open(url, '_self');
};

export const navigateToAnonymousCartBusinessEmail = ({
  referralAdditionalInfo,
}: NavigateToStorefrontParams) => {
  const url = NavigationService.anonymousCartBusinessEmailUrl({
    referralAdditionalInfo,
  });

  window.open(url, '_self');
};

export const navigateToAnonymousCartBusinessEmailViewCart = ({
  referralAdditionalInfo,
}: NavigateToStorefrontParams) => {
  const url = NavigationService.anonymousCartBusinessEmailViewCartUrl({
    referralAdditionalInfo,
  });

  window.open(url, '_self');
};
